import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMetaStore } from '../store/MetaStore'
import LeagueMenuView from '../views/LeagueMenuView'

const LeagueMenuController = () => {
  const setPageTitle = useMetaStore((state) => state.setPageTitle)
  const eventId = useMetaStore((state) => state.eventId)
  const orgId = useMetaStore((state) => state.orgId)
  const navigate = useNavigate()

  useEffect(() => {
    if (!eventId || !orgId) {
      navigate('/error')
      return;
    }
    setPageTitle('League Menu')
  }, [setPageTitle, eventId, orgId, navigate])

  return (
    <LeagueMenuView />
  )
}

export default LeagueMenuController
